module.exports = __webpack_public_path__ + "img/poem.7587a6d2.png";